import curry from 'hs-lodash/curry';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
function errorHandlerFn(error, options = {}) {
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  logger.error(error);
  if ('rethrow' in options && options.rethrow) {
    throw error;
  }
  if ('defaultResult' in options) {
    return options.defaultResult;
  }
}
export const createErrorHandler = createError => {
  return Object.assign(curry((context, cause) => {
    errorHandlerFn(createError(context, cause));
  }), {
    withRethrow: curry((context, cause) => {
      errorHandlerFn(createError(context, cause), {
        rethrow: true
      });
    }),
    withDefaultResult: curry((context, defaultResult, cause) => errorHandlerFn(createError(context, cause), {
      defaultResult
    }))
  });
};